import PostingSupplyForProduction from '@/models/PostingSupplyForProduction/PostingSupplyForProduction';

export default class PostingSupplyForProductionFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.pickingSupplyForProductionId  = '';
		this.pickingSupplyForProductionWorkOrderSupply = '';
		this.workOrderSupplyId  = '';
		this.workOrderSupplyWorkOrderSupplyDate = '';
		this.workOrderProcessId  = '';
		this.workOrderProcessWorkOrderProcessNumber = '';
		this.lineId  = '';
		this.lineCode = '';
		this.workOrderSupplyDateFrom = '';
		this.workOrderSupplyDateTo = '';
		this.documentStatusId  = '';
		this.documentStatusName = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			pickingSupplyForProductionId : '0',
			pickingSupplyForProductionWorkOrderSupply : '0',
			workOrderSupplyId : '0',
			workOrderSupplyWorkOrderSupplyDate : '0',
			workOrderProcessId : '0',
			workOrderProcessWorkOrderProcessNumber : '0',
			lineId : '0',
			lineCode : '0',
			workOrderSupplyDateFrom : '0',
			workOrderSupplyDateTo : '0',
			documentStatusId : '0',
			documentStatusName : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}